import { Colors } from "@/enums/Colors";
import { Avatar, styled } from "@mui/material";
import Image from "next/image";
import DefaultCompanyAvatarPNG from "../../../assets/images/default-company-avatar.png";

const StyledAvatar = styled(Avatar)<{
  avatarSize: number;
  borderColor: string;
  borderWidth: number;
  bgColor: string;
}>(({ avatarSize, borderColor, borderWidth, bgColor }) => ({
  width: `${avatarSize}rem`,
  height: `${avatarSize}rem`,
  backgroundColor: bgColor,
  border: `${borderWidth}px solid ${borderColor}`,
  fontSize: `${avatarSize * 0.375}rem`,
  fontWeight: 600,
  color: "#fff",
}));

function getCompanyInitials(companyName: string): string {
  if (!companyName) {
    return "?";
  }

  const words = companyName.trim().split(/\s+/);
  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }

  return (words[0][0] + words[1][0]).toUpperCase();
}

interface CompanyAvatarProps {
  companyName: string;
  logoUrl?: string | null;
  size?: number;
  borderColor?: string;
  borderWidth?: number;
  backgroundColor?: string;
}

export default function CompanyAvatar({
  companyName,
  logoUrl,
  size = 4,
  borderColor = Colors.LAZO_PURPLE,
  borderWidth = 2,
  backgroundColor = Colors.DARK_GREY_3E3E3E,
}: CompanyAvatarProps) {
  const imageSizeInPixels = size * 16;

  return (
    <StyledAvatar avatarSize={size} borderColor={borderColor} borderWidth={borderWidth} bgColor={backgroundColor}>
      {logoUrl ? (
        <Image
          src={logoUrl}
          alt={companyName}
          width={imageSizeInPixels}
          height={imageSizeInPixels}
          style={{ objectFit: "cover" }}
          onError={(e) => {
            // Fallback to default image on error
            e.currentTarget.src = DefaultCompanyAvatarPNG.src;
          }}
        />
      ) : companyName ? (
        getCompanyInitials(companyName)
      ) : (
        <Image src={DefaultCompanyAvatarPNG} alt="Company" width={imageSizeInPixels} height={imageSizeInPixels} />
      )}
    </StyledAvatar>
  );
}
